import React, { Ref } from 'react'
import { TextArea } from '@paypalcorp/pp-react'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import { useAppSelector } from '../../../store/hooks'
import { selectTitle } from '../../../store/slices/groupFormSlice'
import { isCoverOnCreateFlowEnabled } from '../../../utils/features'

interface TitleProps {
  error?: string
  handleOnChange: Function
  titleRef?: Ref<HTMLTextAreaElement>
}

const GroupTitle = (props: TitleProps) => {
  const title = useAppSelector(selectTitle)
  const { getContent } = useLocalizedContent()
  const maxCharacters = 70

  const handleTitleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    props.handleOnChange(evt.target.value)
  }

  return (
    <TextArea
      name="title"
      value={title}
      onChange={handleTitleChange}
      label={getContent('create.view.title')}
      labelClassName="test"
      data-testid="group-title-input"
      errorText={props.error}
      maxCharacters={maxCharacters}
      showCharacterCounter={!isCoverOnCreateFlowEnabled()}
      maxRows={isCoverOnCreateFlowEnabled() ? 2 : 6}
      ref={props.titleRef}
    />
  )
}
export default GroupTitle
